import React from 'react';
import {
  Box,
  VStack,
  Text,
  Card,
  CardBody,
  Icon,
  Badge,
  HStack,
  Switch,
  Flex,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon
} from '@chakra-ui/react';
import { FaTools } from 'react-icons/fa';

const FunctionCallingPanel = ({ 
  availableFunctions = [], 
  toggleFunction = () => {} 
}) => {
  // Safe filter with default empty array
  const enabledFunctions = availableFunctions.filter(f => f && f.enabled);

  return (
    <Accordion allowToggle>
      <AccordionItem>
        <AccordionButton>
          <Box flex="1" textAlign="left">
            <HStack>
              <Icon as={FaTools} />
              <Text fontWeight="bold">Function Calling Configuration</Text>
              <Badge colorScheme="green" ml={2}>
                {enabledFunctions.length} enabled
              </Badge>
            </HStack>
          </Box>
          <AccordionIcon />
        </AccordionButton>
        <AccordionPanel pb={4}>
          <VStack spacing={4} align="stretch">
            <Text fontSize="sm" color="gray.600">
              Enable business functions that the AI can call to perform actions for customers:
            </Text>
            
            {availableFunctions.length === 0 ? (
              <Text fontSize="sm" color="gray.500" textAlign="center" py={4}>
                No functions available
              </Text>
            ) : (
              availableFunctions.map((func) => (
                <Card key={func.name} bg="white" border="1px solid" borderColor="gray.200">
                  <CardBody p={4}>
                    <Flex align="start" justify="space-between">
                      <HStack spacing={3} flex="1">
                        <Icon 
                          as={func.icon} 
                          color={`${func.color}.500`} 
                          boxSize={5} 
                        />
                        <VStack align="start" spacing={1} flex="1">
                          <HStack>
                            <Text fontWeight="bold">{func.name}</Text>
                            <Badge 
                              colorScheme={func.enabled ? 'green' : 'gray'}
                              size="sm"
                            >
                              {func.enabled ? 'Enabled' : 'Disabled'}
                            </Badge>
                          </HStack>
                          <Text fontSize="sm" color="gray.600">
                            {func.description}
                          </Text>
                          <Text fontSize="xs" color="gray.500">
                            Parameters: {func.parameters?.properties ? Object.keys(func.parameters.properties).join(', ') : 'None'}
                          </Text>
                        </VStack>
                      </HStack>
                      <Switch
                        isChecked={func.enabled}
                        onChange={() => toggleFunction(func.name)}
                        colorScheme={func.color}
                        size="lg"
                      />
                    </Flex>
                  </CardBody>
                </Card>
              ))
            )}
          </VStack>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default FunctionCallingPanel;